import { render, staticRenderFns } from "./Trait.vue?vue&type=template&id=8de1a23a&scoped=true&"
import script from "./Trait.vue?vue&type=script&lang=js&"
export * from "./Trait.vue?vue&type=script&lang=js&"
import style0 from "./Trait.vue?vue&type=style&index=0&id=8de1a23a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de1a23a",
  null
  
)

export default component.exports